import { Card } from '@frontendmentorio/design-system-v2';

import Content from './Content';
import SolutionPreview from 'features/solutions/SolutionPreview';

export default function CardWithSolution({ comment }) {
  if (!comment.solution) return null;

  return (
    <Card className="flex flex-col gap-6 p-5" tagName="li">
      <SolutionPreview solution={comment.solution} />
      <Content comment={comment} />
    </Card>
  );
}
